import React, { createContext, useEffect, useContext, useState, useCallback } from 'react';
import { useCreateSubscriptionContext } from './createSubscriptionContext';
import { useTranslation } from 'react-i18next';
import { DEFAULT_FONT_FOR_LOCALISED_LANGUAGES } from '../utils/helper';

const INITIAL_STATE = (currentLanguage) => ({
    fontSize: 16,
    fontFamily: currentLanguage,
})

const ComplexDefaultStyleContext = createContext(null);

export const useDefaultStyleContext = (selector, customName = '', debug = false) => {
    const store = useContext(ComplexDefaultStyleContext);
    if (!store) {
        throw new Error('Store not found');
    }

    const [state, setState] = useState(selector(store.get()));

    useEffect(() => {
        return store.subscribe(() => {
            setState(previousState => {
                if (debug) {
                    console.log("Change in context :: ", customName, selector(store.get()), previousState, previousState === selector(store.get()));
                }
                return selector(store.get(), previousState);
            });
        }, debug ? customName : '');
    }, []);

    useEffect(() => {
        if (debug) console.log("context change reflected in state :: ", customName, state, store.get())
    }, [state, debug, customName]);

    return [state, store];
}

const Provider = ({ children, customState, customName = 'defaultStyle' }) => {
    const { i18n } = useTranslation();
    const currentLanguage = DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(i18n.language);

    const store = useCreateSubscriptionContext(Object.assign({}, INITIAL_STATE(currentLanguage), customState), undefined, false, customName);

    store.reset = useCallback(() => {
        store.set(INITIAL_STATE(currentLanguage));
    }, []);

    useEffect(() => {
        store.set(Object.assign({}, INITIAL_STATE(currentLanguage), customState));
    }, [customState]);

    return (
        <ComplexDefaultStyleContext.Provider value={store}>
            {children}
        </ComplexDefaultStyleContext.Provider>
    );
}

export default Provider;
